import { createStore } from 'redux'

const initialState = {
  shippingCost: 0.00,
  selectedQuote: {},
  quotes: [],
  totals: {} 
}


const shoppingCartReducer = (state = initialState, action) => {
  switch(action.type){
    default:
      return state;
  }
}

const store = createStore(shoppingCartReducer);

const ReduxStore = () => { return store; }

export default ReduxStore;

